import { motion } from "framer-motion";

export default function PageHeader({ overline, title, accent, subtitle }) {
  return (
    <section
      className="relative pt-40 md:pt-48 pb-16 md:pb-24 bg-[var(--cream)] border-b border-[var(--border)] overflow-hidden"
      data-testid="page-header"
    >
      <div className="absolute inset-x-0 bottom-0 tricolore h-[2px] opacity-60" />
      <div className="container-wide relative">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="overline inline-block"
        >
          {overline}
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="h-display text-5xl md:text-7xl lg:text-8xl mt-6 text-[var(--anthracite)] max-w-[18ch]"
        >
          {title}
          {accent && (
            <>
              {" "}
              <span className="italic-accent text-[var(--sage-dark)]">{accent}</span>
            </>
          )}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.25 }}
            className="mt-8 text-base md:text-lg text-[var(--muted-fg)] max-w-xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
